export default __webpack_public_path__ + "static/media/ne.9a6fb3e5.svg";